import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../../store'
import { isMobileDevice } from '../../utils/device'

Vue.use(VueRouter)

const HomePage = () => import(/* webpackChunkName: "page-home" */ '../../pages/home/index.vue')
const HousePage = () => import(/* webpackChunkName: "page-house" */ '../../pages/house/index.vue')
const HomeMobile = () => import(/* webpackChunkName: "page-home-mobile" */ '../../pages/home/mobile.vue')
const HouseMobile = () => import(/* webpackChunkName: "page-house-mobile" */ '../../pages/house/mobile.vue')

const routes = [
  { path: '/', redirect: '/home' },

  // Desktop pages
  { name: 'home', path: '/home', component: HomePage },
  { name: 'bpartner', path: '/bpartner', component: () => import(/* webpackChunkName: "page-bpartner" */ '../../pages/bpartner/index.vue') },
  { name: 'about', path: '/about', component: () => import(/* webpackChunkName: "page-about" */ '../../pages/about/index.vue') },

  // House routes – all served by the same component, differentiated by name/path
  { name: 'house', path: '/house', component: HousePage },
  { name: 'Office', path: '/house/office', component: HousePage },
  { name: 'Ruko', path: '/house/shophouse', redirect: '/house/office' },
  { name: 'Factory', path: '/house/factory', component: HousePage },
  { name: 'Warehouse', path: '/house/warehouse', component: HousePage },
  { name: 'Land', path: '/house/land', component: HousePage },

  { name: 'detail', path: '/detail', component: () => import(/* webpackChunkName: "page-detail" */ '../../pages/detail/index.vue') },
  { name: 'pk', path: '/pk', component: () => import(/* webpackChunkName: "page-pk" */ '../../pages/pk/index.vue') },

  // Mobile pages
  { name: 'home-mobile', path: '/home/mobile', component: HomeMobile },
  { name: 'bpartner-mobile', path: '/bpartner/mobile', component: () => import(/* webpackChunkName: "page-bpartner-mobile" */ '../../pages/bpartner/mobile.vue') },
  { name: 'about-mobile', path: '/about/mobile', component: () => import(/* webpackChunkName: "page-about-mobile" */ '../../pages/about/mobile.vue') },
  { name: 'house-mobile', path: '/house/mobile', component: HouseMobile },
  { name: 'detail-mobile', path: '/detail/mobile', component: () => import(/* webpackChunkName: "page-detail-mobile" */ '../../pages/detail/mobile.vue') },
  { name: 'pk-mobile', path: '/pk/mobile', component: () => import(/* webpackChunkName: "page-pk-mobile" */ '../../pages/pk/mobile.vue') },

  // 接口/业务错误页
  { name: 'error', path: '/error', component: { render: (h) => h('div') } },

  // Catch-all
  { path: '*', redirect: '/home' },
]

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { x: 0, y: 0 }
  },
})

const isMobileLayout = isMobileDevice()

const BUSINESS_ROUTE_NAMES = new Set([
  'house',
  'Office',
  'Ruko',
  'Factory',
  'Warehouse',
  'Land',
  'detail',
  'pk',
  'house-mobile',
  'detail-mobile',
  'pk-mobile',
])

function hasDetailQuery(query) {
  return !!(query.sharingRecordId || query.id)
}

function buildDetailQuery(query) {
  const detailQuery = { tenantId: query.tenantId }
  if (query.sharingRecordId) detailQuery.sharingRecordId = query.sharingRecordId
  if (query.id) detailQuery.id = query.id
  return detailQuery
}

function finishNavigation(to, next) {
  if (BUSINESS_ROUTE_NAMES.has(to.name) && Vue.prototype.$api) {
    store.dispatch('initBusinessData', { $api: Vue.prototype.$api })
  }
  next()
}

router.beforeEach((to, from, next) => {
  if (to.name === 'error') {
    return next()
  }
  if (isMobileLayout) {
    store.commit('setLayout', 'mobile')
    if (!to.path.includes('/mobile')) {
      if (to.name === 'detail' && hasDetailQuery(to.query)) {
        return next({ path: '/detail/mobile', query: buildDetailQuery(to.query) })
      } else if (to.name === 'pk' && to.query.id) {
        return next({ path: '/pk/mobile', query: { id: to.query.id } })
      } else if (to.name === 'bpartner') {
        return next('/bpartner/mobile')
      } else {
        return next('/home/mobile')
      }
    }
  } else {
    store.commit('setLayout', 'default')
    if (to.path === '/detail/mobile' && hasDetailQuery(to.query)) {
      return next({ path: '/detail', query: buildDetailQuery(to.query) })
    } else if (to.path === '/pk/mobile' && to.query.id) {
      return next({ path: '/pk', query: { id: to.query.id } })
    } else if (to.path === '/bpartner/mobile') {
      return next('/bpartner')
    } else if (to.path.includes('/mobile')) {
      return next('/home')
    }
  }
  finishNavigation(to, next)
})

export default router
